import React from 'react';
import { Zap, Search, Clock, Shield } from 'lucide-react';
import { AnimatedGradient } from './ui/animated-gradient';

const WhyChoose: React.FC = () => {
  const benefits = [
    {
      icon: Zap,
      title: "Smarter, Faster, More Powerful",
      description: "Our AI-powered solution delivers insights more intelligently and efficiently than traditional methods.",
      color: "from-yellow-400 to-orange-500"
    },
    {
      icon: Search,
      title: "Recover Lost Insights",
      description: "Don't let valuable data get lost in the noise. We ensure you capture the insights that drive revenue and customer satisfaction.",
      color: "from-blue-400 to-blue-600"
    },
    {
      icon: Clock,
      title: "Reduce Manual QA",
      description: "Say goodbye to time-consuming manual quality assurance processes.",
      color: "from-green-400 to-green-600"
    },
    {
      icon: Shield,
      title: "Mitigate Compliance Risk",
      description: "Our comprehensive analysis helps you stay on top of compliance requirements and reduce risk.",
      color: "from-purple-400 to-purple-600"
    }
  ];

  return (
    <section id="why-choose" className="relative py-20 lg:py-32 overflow-hidden">
      <AnimatedGradient />
      <div className="max-w-7xl mx-auto px-8 sm:px-12 lg:px-16 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Choose ConvaLytics AI?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your call center operations with AI-powered insights that deliver measurable results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#0E666F]/20 group"
            >
              <div className="flex items-start space-x-4">
                <div className={`p-3 rounded-xl bg-gradient-to-r ${benefit.color} shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <benefit.icon className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-[#0E666F] transition-colors duration-300">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-[#0E666F] mb-2">100%</div>
              <div className="text-gray-600">Call Coverage</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#0E666F] mb-2">90%</div>
              <div className="text-gray-600">Time Saved</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#0E666F] mb-2">24/7</div>
              <div className="text-gray-600">AI Analysis</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
